import React from 'react'
import { useI18n } from '../../i18n'
import { featureFlags } from '../../config/featureFlags'
import { GovernanceListingSection } from '../governance/GovernanceListingSection'
import { fetchRuntimeTimeline } from '../../services/complianceRuntimeApi'
import OperationalEventTimeline from './OperationalEventTimeline'

type Props = {
  standardCode?: string
}

export default function InformationSystemOperationalEventsPanel({ standardCode }: Props) {
  const { t } = useI18n()
  const [items, setItems] = React.useState<Array<{ id: string; at: string; eventType: string; severity: string; summary: string }>>([])

  React.useEffect(() => {
    if (!featureFlags.COMPLIANCE_RUNTIME_V1 || !standardCode) return
    void fetchRuntimeTimeline(standardCode).then((d) => setItems(d.timeline || []))
  }, [standardCode])

  if (!featureFlags.COMPLIANCE_RUNTIME_V1) return null

  return (
    <GovernanceListingSection
      title={t('complianceRuntime.operationalEventStream', 'Operational event stream')}
      description={t('complianceRuntime.isEventsHint', 'Certification-impacting and remediation events for this standard scope.')}
    >
      <OperationalEventTimeline items={items} compact />
    </GovernanceListingSection>
  )
}
